import { render } from "./GisDocumentDesignerDatasetJoin.vue?vue&type=template&id=03895c24&ts=true"
import script from "./GisDocumentDesignerDatasetJoin.vue?vue&type=script&lang=ts"
export * from "./GisDocumentDesignerDatasetJoin.vue?vue&type=script&lang=ts"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__